(() => {
  const init = (intro) => {
    if (intro.dataset.introReady) return;

    const content = intro.querySelector('[data-collection-intro-content]');
    const toggle = intro.querySelector('[data-collection-intro-toggle]');
    if (!content || !toggle) return;

    intro.dataset.introReady = 'true';
    let expanded = false;

    const update = () => {
      const lines = window.matchMedia('(max-width: 749px)').matches ? 2 : 4;
      const styles = window.getComputedStyle(content);
      const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.5;

      const fullHeight = content.scrollHeight;
      const collapsedHeight = Math.ceil(lineHeight * lines + 4);
      const canCollapse = fullHeight > collapsedHeight + 1;

      if (!canCollapse) {
        expanded = false;
        intro.classList.remove('is-expanded');
        content.style.maxHeight = 'none';
        toggle.hidden = true;
        return;
      }

      content.style.maxHeight = `${expanded ? fullHeight : collapsedHeight}px`;
      intro.classList.toggle('is-expanded', expanded);
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', expanded);
      toggle.textContent = expanded ? 'Read less' : 'Read more';
    };

    toggle.addEventListener('click', () => {
      expanded = !expanded;
      update();
    });

    window.addEventListener('resize', update, { passive: true });
    update();
    intro.classList.add('is-ready');
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-collection-intro]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
